import styled from 'styled-components';
import Search from 'common/icons/Search';

import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    BORDER_PROPERTIES,
    FONT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const SessionSearchContainer = styled.div`
    position: relative;
`;

export const SearchInput = styled.input`
    padding: 0.75rem;
    padding-right: 2.5rem;
    width: 100%;
    height: 100%;

    ${FONT_PROPERTIES}
    ::placeholder {
        ${FONT_PROPERTIES}
    }

    border-style: solid;
    ${BORDER_PROPERTIES}

    background-color: ${(props) => props.$backgroundColor};

    &:hover,
    &:active,
    &:focus {
        ${BORDER_PROPERTIES}
        background-color: ${(props) => props.$backgroundColorHover};
        border-color: ${(props) => props.$borderColorHover};
        color: ${(props) => props.$fontColorHover};
    }

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const StyledSearchIcon = styled(Search)`
    position: absolute;
    top: 50%;
    right: 0.75rem;
    transform: translateY(-50%);
    color: ${(props) => props.$iconColor};
`;
